import { useEffect } from 'react';

let blocks: string[] = [];

function applyBlock(key: string, block: boolean) {
  blocks = blocks.filter(k => k !== key);
  if (block) {
    document.body.style.overflow = 'hidden';
    blocks.push(key);
  } else if (!blocks.length) {
    document.body.style.overflow = null;
  }
}

export default function (key: string, block: boolean, inEffect = false) {
  if (inEffect) {
    applyBlock(key, block);
  } else {
    useEffect(() => applyBlock(key, block));
  }
}
